module.exports = __webpack_public_path__ + "img/ellipsis_opaque.ed27f614.svg";